// extracted by mini-css-extract-plugin
export default {"home":"Home_home__VceHV","little":"Home_little__RWk7n","text-box":"Home_text-box__tz54H","img-box":"Home_img-box__c3K0e"};